import React, { useEffect, useState } from "react";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";
import TableAHSF from "../../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetAdvertisingAndMediaPlanForTheProject } from "../../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject";
import AddEdit from "./AddEdit";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../../Components/PopupAHSF";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";

function MarketingResourcesAndPublications() {
  const dispatch = useDispatch();
  const AppGuid = useParams();

  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);

  const [
    MarketingResourcesAndPublicationsId,
    setMarketingResourcesAndPublicationsId,
  ] = useState(null);

  const state = useSelector((state) => {
    return {
      AdvertisingAndMediaPlanForTheProject:
        state.AdvertisingAndMediaPlanForTheProject
          .AdvertisingAndMediaPlanForTheProject,
      loadingGetAdvertisingAndMediaPlanForTheProject:
        state.AdvertisingAndMediaPlanForTheProject
          .loadingGetAdvertisingAndMediaPlanForTheProject,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );

  const RequestAccessor = [
    {
      KeyName: "itemNameAr",
      ShowStatus: true,
      NmaeColumn: "البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    // {
    //   KeyName: "itemNameAnother",
    //   ShowStatus: true,
    //   NmaeColumn: "ادخال اسم البند في حال تم اختيار اخرى",
    //   TotalNumber: false,
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
    {
      KeyName: "mediaAndAdvertisingPlanExplanation",
      ShowStatus: true,
      NmaeColumn: "وصف المحتوى",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "descriptionContentObjective",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "quantity",
      ShowStatus: true,
      NmaeColumn: "الكمية",
      TotalNumber: false,
      DropdownFiltrationStatus: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      GroupOfColumns: false,
      comma: true,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        setMarketingResourcesAndPublicationsId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      //
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action it will delete row
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/MP_MarketingResourcesAndPublications/DeleteMP_MarketingResourcesAndPublicationsData",
              {
                mP_MarketingResourcesAndPublicationsId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        // const encryptValue = encrypt(e.target.value, "key");
        // const para = encodeURIComponent(encryptValue)
        // navigate(`/innovation/TasksPage/${para}`)
        // dispatch(SetapplicationInformationGUIDForShowEmployee(e.target.value))
        // handleOpenModal()
        //console.log("545855");
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsColumns = [
    " رقمkm الطلب",
    " اسم المتقدم",
    " اسم المشروع",
    " اسم المشروع",
    "الحقل",
    "نوع المستفيد",
    " تاريخ تقديم الطلب",
    "حالة الssssطلب",
  ];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataAddStatus,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <AddEdit />
      </div>
    ),
    title: "الموارد التسويقية والمطبوعات",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };
  //to get json data from  main.js 
  const getJson = async () => {
    var json = await loadConfig();
    return json;
  };
  //then set data into state
  useEffect(() => {
    setJsonData(getJson());
  }, []);
  //to get data for GetAdvertisingAndMediaPlanForTheProject by Application guid from storage or params
  useEffect(() => {
    dispatch(
      GetAdvertisingAndMediaPlanForTheProject(
        state.ApplicationInformation.aI_ApplicationInformationId ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);
  
//popup props for update
  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEdit
          MarketingResourcesAndPublicationsId={
            MarketingResourcesAndPublicationsId
          }
          canEdit="edit"
        />
      </div>
    ),
    title: "الموارد التسويقية والمطبوعات",
    maxWidth: "500px",
    maxHeight: "500px",
  };
//after get data render html
  return !state.loadingGetAdvertisingAndMediaPlanForTheProject ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"mP_MarketingResourcesAndPublicationsId"}
        valueButtonAction={"mP_MarketingResourcesAndPublicationsId"}
        URL={`api/MP_MarketingResourcesAndPublications/GetMP_MarketingResourcesAndPublicationsListData`}
        UrlBody={{
          aP_AdvertisingAndMediaPlanId:
            state.AdvertisingAndMediaPlanForTheProject
              ?.aP_AdvertisingAndMediaPlanId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الموارد التسويقية والمطبوعات"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  ) : (
    ""
  );
}

export default MarketingResourcesAndPublications;
